import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="常见问题"
            title="举报前，你可能想先弄清楚这些"
            description="关于受理时效、证据材料、隐私保护与结果公示，我们把问得最多的几个问题整理在这里。"
          />
        </div>

        <div className="lg:col-span-8">
          <ul className="border-t border-background-200">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <li key={item.q} className="border-b border-background-200">
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : index)}
                      aria-expanded={open}
                      className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                        {item.q}
                      </span>
                      <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full border border-background-300 text-foreground-600">
                        <i className={open ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <div className="pb-5 pr-10 -mt-1 text-sm md:text-base leading-relaxed text-foreground-600">
                      {item.a}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}